import React from 'react';
import { WarningCircle, ArrowClockwise } from '@phosphor-icons/react';

export default class IncubatorPageBoundary extends React.Component {
  state = { error: false };
  static getDerivedStateFromError() { return { error: true }; }
  componentDidCatch(error, info) {
    console.error('[Incubator page] Render failed:', error, info);
    this.props.onError?.();
  }
  componentDidUpdate(previous) {
    if (this.state.error && previous.resetKey !== this.props.resetKey) this.setState({ error: false });
  }
  retry = () => {
    this.setState({ error: false });
    this.props.onRetry?.();
  };
  render() {
    if (!this.state.error) return this.props.children;
    return <section className="inc-page inc-empty" role="alert">
      <WarningCircle size={36}/>
      <h2>This page couldn’t be displayed</h2>
      <p>Your workspace is still available. Try again, or use the navigation to open another section.</p>
      <button className="inc-gold-button" onClick={this.retry}><ArrowClockwise size={17}/>Try again</button>
    </section>;
  }
}
